/**
 * Utilitários centralizados para máscaras de formulário
 * Usados para exibir (format) e salvar (strip) dados em campos restritos
 */

/**
 * Remove todos os caracteres não-dígitos da string
 */
export function stripMask(masked: string | null | undefined): string {
  if (!masked) return '';
  return String(masked).replace(/\D/g, '');
}

/**
 * Formata um CPF no padrão: 000.000.000-00
 */
export function formatCpf(raw: string | null | undefined): string {
  const digits = stripMask(raw).slice(0, 11);
  if (!digits) return '';

  if (digits.length <= 3) return digits;
  if (digits.length <= 6) return `${digits.slice(0, 3)}.${digits.slice(3)}`;
  if (digits.length <= 9) return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6)}`;
  return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6, 9)}-${digits.slice(9)}`;
}

/**
 * Strips a CPF mask.
 */
export function stripCpf(masked: string | null | undefined): string {
  return stripMask(masked);
}

/**
 * Formata um telefone no padrão: (00) 0000-0000 ou (00) 00000-0000
 */
export function formatPhone(raw: string | null | undefined): string {
  const digits = stripMask(raw).slice(0, 11);
  if (!digits) return '';

  if (digits.length <= 2) return `(${digits}`;
  if (digits.length <= 6) return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
  if (digits.length <= 10) return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`;
  return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
}

/**
 * Strips a phone mask.
 */
export function stripPhone(masked: string | null | undefined): string {
  return stripMask(masked);
}

/**
 * Formata um CEP no padrão: 00000-000
 */
export function formatCep(raw: string | null | undefined): string {
  const digits = stripMask(raw).slice(0, 8);
  if (!digits) return '';

  if (digits.length <= 5) return digits;
  return `${digits.slice(0, 5)}-${digits.slice(5)}`;
}

/**
 * Strips a CEP mask.
 */
export function stripCep(masked: string | null | undefined): string {
  return stripMask(masked);
}
